import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper } from "@material-ui/core";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Label,
} from "recharts";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";
import RatingChart from "../../components/RatingChart";
import { CSVLink } from "react-csv";
import { saveAs } from "file-saver";
import { FaBuilding, FaLaptopHouse } from "react-icons/fa";
import { VscVmActive } from "react-icons/vsc";
import { PiGitBranch } from "react-icons/pi";
import { BsBuildingsFill } from "react-icons/bs";
import { HiStatusOffline } from "react-icons/hi";
import {
  Card,
  CardContent,
  Typography,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { IoPeopleCircleOutline, IoLockClosedSharp } from "react-icons/io5";
import { TbLiveView } from "react-icons/tb";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx/xlsx.mjs";
import LeaderboardTable from "../../components/LeaderboardTable";

import { API_URL } from "../../utils/config";
const COLORS = ["#2C7865", "#FF9800", "#E72929"];
const failedList = [
  "#FF0000",
  "#FF3300",
  "#FF6600",
  "#FF9900",
  "#FFCC00",
  "#FFFF00",
  "#CCFF00",
  "#99FF00",
  "#66FF00",
  "#33FF00",
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {/* {data[index].value} */}
    </text>
  );
};

const renderCustomizedLabelPercent = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Adding shadow
  },
}));

const ReportManage = () => {
  const classes = useStyles();
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(localStorage.getItem("companyID"));
  const [courses, setCourses] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [courseStatus, setCourseStatus] = useState(null);
  const [course, setCourse] = useState("");
  const [isGraphs, setIsGraphs] = useState(true);
  const [ratingsData, setRatingsData] = useState([]);
  const [graphID, setGraphID] = useState(0);
  const [category] = useState([
    { _id: 1, name: "Awareness" },
    { _id: 2, name: "Compliance" },
    { _id: 3, name: "Short Bytes" },
  ]);
  const [stats, setStats] = useState({
    totalCompanies: 0,
    totalEmployees: 0,
    totalCourses: 0,
    liveEmployeesToday: 0,
  });
  const [quizTrackingData, setQuizTrackingData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(1);
  const [selectedCategoryQuiz, setSelectedCategoryQuiz] = useState("");
  const [categoryQuizs, setCategoryQuizs] = useState([]);
  const [attemptAwareness, setAttemptAwareness] = useState([]);
  const [attemptCompliance, setAttemptCompliance] = useState([]);
  const [attemptShort, setAttemptShort] = useState([]);
  const [courseCompletionReport, setCourseCompletionReport] = useState([]);
  const [mostToLeast, setMostToLeast] = useState([]);
  const [mostFailedEmployee, setMostFailedEmployee] = useState([]);
  const [courseTimeCompletionReport, setCourseTimeCompletionReport] = useState(
    []
  );
  const [
    courseWithin14DaysCompletionReport,
    setCourseWithin14DaysCompletionReport,
  ] = useState([]);
  const [learningScoreChart, setLearningScoreChart] = useState({
    overallAverageScore: "0",
    categoryPercentages: [],
  });
  const [filter, setFilter] = useState("");

  const fetchDashboard = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/admin/counts`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => {
          setStats({
            totalCompanies: result.companyCount,
            totalEmployees: result.employeeCount,
            totalCourses: result.courseCount,
            liveEmployeesToday: result.activeEmployeeCount,
          });
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategoryQuizs = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/categoryQuiz`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setCategoryQuizs(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRating = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/ratings-count/${company}`;
    if (course) {
      apiUrl += `?courseId=${course}`;
    }
    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setRatings(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchQuizCategoryTable = async (urlAppend) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", localStorage.getItem("token"));

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/quizTracking/${urlAppend}`;
    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setQuizTrackingData(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchQuizCategoryTableScore = async (urlAppend) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", localStorage.getItem("token"));

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/quizTrackingScore/${urlAppend}`;
    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setQuizTrackingData(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseStatus = async () => {
    try {
      let apiUrl = `${API_URL}/course-status-data/${company}`;
      if (course) {
        apiUrl += `?courseId=${course}`;
      }
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      const data = await response.json();
      setCourseStatus(data);
    } catch (error) {
      console.error("Error fetching course status:", error);
    }
  };

  const fetchQuizTrackingData = async () => {
    try {
      let apiUrl = `${API_URL}/quizTrackingData?companyID=${company}`;
      if (course) {
        apiUrl += `&courseId=${course}`;
      }
      const response = await fetch(apiUrl, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      const data = await response.json();
      console.log(data);
      setLearningScoreChart(data);
    } catch (error) {
      console.error("Error fetching course status:", error);
    }
  };

  useEffect(() => {
    fetchCourses(company);
    fetchCourseCompletionReport(company);
    fetchCourseAttemptBarGraph(company);
    fetchCourseMostToLeast();
    fetchCourseMostFailedEmployee();
    fetchRating();
    fetchCourseStatus();
    fetchQuizTrackingData();
    fetchData();
  }, [company, course]);

  useEffect(() => {
    fetchDashboard();
    fetchCompanies();
    fetchCategoryQuizs();
  }, []);

  const fetchData = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      let apiUrl = `${API_URL}/ratings?page=1&pageSize=1000`;
      if (company) {
        apiUrl += `&companyId=${company}`; // Append company ID if selected
      }
      if (course) {
        apiUrl += `&courseId=${course}`; // Append company ID if selected
      }
      const response = await fetch(apiUrl, requestOptions);
      const data = await response.json();
      setRatingsData(data.results);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const fetchCourses = async (company) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${API_URL}/admin/courses-company/${company}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setCourses(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseCompletionReport = (urlAppend) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${API_URL}/course-status/${urlAppend}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setCourseCompletionReport(result.response);
        setCourseTimeCompletionReport(result.responseTime);
        setCourseWithin14DaysCompletionReport(
          result.responseWithin14Days[0].value
        );
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseAttemptBarGraph = (urlAppend) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${API_URL}/company/${urlAppend}/data`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setAttemptAwareness(result.awarenessCourseResult);
        setAttemptCompliance(result.complainceCourseResult);
        setAttemptShort(result.nanoBytesCourseResult);
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseMostToLeast = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/quizTracking/${company}/isCorrectCount`;
    if (course) {
      apiUrl += `?courseId=${course}`;
    }
    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMostToLeast(result);
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseMostFailedEmployee = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/quizTracking/${company}/mostFailedEmployee`;
    if (course) {
      apiUrl += `?courseId=${course}`;
    }
    fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMostFailedEmployee(result);
      })
      .catch((error) => console.error(error));
  };

  const dataPercentage =
    selectedCategory == 1
      ? attemptAwareness.map((item) => ({
          name: item.name,
          attempt1: Math.floor(
            (item.attempt1 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt2: Math.floor(
            (item.attempt2 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt3: Math.floor(
            (item.attempt3 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
        }))
      : selectedCategory == 2
      ? attemptCompliance.map((item) => ({
          name: item.name,
          attempt1: Math.floor(
            (item.attempt1 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt2: Math.floor(
            (item.attempt2 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt3: Math.floor(
            (item.attempt3 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
        }))
      : attemptShort.map((item) => ({
          name: item.name,
          attempt1: Math.floor(
            (item.attempt1 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt2: Math.floor(
            (item.attempt2 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
          attempt3: Math.floor(
            (item.attempt3 / (item.attempt1 + item.attempt2 + item.attempt3)) *
              100
          ),
        }));

  const handleDownload = () => {
    const workbook = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([], {
      header: [
        "Total Attempts",
        "Name",
        "Quiz",
        "Material",
        "Course",
        "Category",
        "Times Failed",
      ],
    });

    // Adjust column widths
    ws["!cols"] = [
      { wch: 15 }, // Total Attempts
      { wch: 30 }, // Name
      { wch: 30 }, // Quiz
      { wch: 30 }, // Material
      { wch: 20 }, // Course
      { wch: 20 }, // Category
      { wch: 15 }, // Times Failed
    ];

    mostFailedEmployee.forEach((employee) => {
      XLSX.utils.sheet_add_json(
        ws,
        [
          {},
          {
            "Total Attempts": employee.value,
            Name: `${employee.name.firstName} ${employee.name.lastName}`,
          },
        ],
        { skipHeader: true, origin: -1 }
      );

      employee.failedQuizzes.forEach((item) => {
        const material = item.courseID.videosWithQuizzes.find(
          (element) => element._id === item.materialID
        );
        const quiz = material
          ? material.quiz.find((element) => element._id === item.quizID)
          : null;

        XLSX.utils.sheet_add_json(
          ws,
          [
            {
              Quiz: quiz ? quiz.question : "",
              Material: material ? material.video.title : "",
              Course: item.courseID.title,
              Category: item.categoryID.name,
              "Times Failed": item.timesFailed,
            },
          ],
          { skipHeader: true, origin: -1 }
        );
      });

      // Add an empty row between each employee
      XLSX.utils.sheet_add_json(ws, [], { skipHeader: true, origin: -1 });
    });

    XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");

    const xlsxBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([xlsxBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "table_data.xlsx");
  };

  const csvData = courseStatus
    ? graphID == 1
      ? courseStatus.response.data
          .filter(
            (item) =>
              filter === "" || filter === "All" || item.status === filter
          )
          .map((item) => ({
            User: `${item.user.firstName} ${item.user.lastName}`,
            Email: `${item.user.email}`,
            "Course Name": item.course.title,
            Status: item.status,
            "Creation Date": item.course
              ? new Date(item.course.createdAt).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Due Date": item.course
              ? new Date(item.course.dueDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Completion Date": item.courseCompletionDate
              ? new Date(item.courseCompletionDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
          }))
      : graphID == 2
      ? courseStatus.responseTime.data
          .filter(
            (item) =>
              filter === "" || filter === "All" || item.status === filter
          )
          .map((item) => ({
            User: `${item.user.firstName} ${item.user.lastName}`,
            Email: `${item.user.email}`,
            "Course Name": item.course.title,
            Status: item.status,
            "Creation Date": item.course
              ? new Date(item.course.createdAt).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Due Date": item.course
              ? new Date(item.course.dueDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Completion Date": item.courseCompletionDate
              ? new Date(item.courseCompletionDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
          }))
      : graphID == 3
      ? courseStatus.responseWithin14Days.data
          .filter((item) => item.courseCompletionDate)
          .map((item) => ({
            User: `${item.user.firstName} ${item.user.lastName}`,
            Email: `${item.user.email}`,
            "Course Name": item.course.title,
            Status: item.status,
            "Creation Date": item.course
              ? new Date(item.course.createdAt).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Due Date": item.course
              ? new Date(item.course.dueDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
            "Completion Date": item.courseCompletionDate
              ? new Date(item.courseCompletionDate).toLocaleString("en-IN", {
                  timeZone: "Asia/Kolkata",
                })
              : "N/A",
          }))
      : graphID == 4
      ? mostToLeast
          .filter(
            (item) =>
              selectedCategoryQuiz === "" ||
              selectedCategoryQuiz === "All" ||
              item.categoryID._id === selectedCategoryQuiz
          )
          .sort((a, b) => b.value - a.value)
          .map((item, index) => {
            const material = item.courseID.videosWithQuizzes.find(
              (element) => element._id === item.materialID
            );
            const quiz = material
              ? material.quiz.find((element) => element._id === item.name)
              : null;
            return {
              Attempt: item.value,
              Category: item.categoryID.name,
              Course: item.courseID.title,
              Video: material ? material.video.title : "",
              "Quiz Question": quiz ? quiz.question : "",
            };
          })
      : graphID == 5
      ? mostFailedEmployee.map((employee) => ({
          "Total Attempts": employee.value,
          Name: `${employee.name.firstName} ${employee.name.lastName}`,
          Email: `${employee.name.email}`,
          "Failed Quizzes": employee.failedQuizzes
            .map((item) => {
              const material = item.courseID.videosWithQuizzes.find(
                (element) => element._id === item.materialID
              );
              const quiz = material
                ? material.quiz.find((element) => element._id === item.quizID)
                : null;
              return `${quiz ? quiz.question : ""}, ${
                material ? material.video.title : ""
              }, ${item.courseID.title}, ${item.categoryID.name}, ${
                item.timesFailed
              }`;
            })
            .join("\n"),
        }))
      : ""
    : "";

  return (
    <Grid
      item
      sm={10}
      style={{
        height: "92vh",
        overflowY: "scroll",
        padding: "20px",
        width: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "start",
        alignContent: "center",
        alignItems: "start",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid
        item
        spacing={3}
        style={{
          width: "100%",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <h4 style={{ color: "black" }}>Dashboard and Reporting</h4>
        <div
          style={{
            alignContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {isGraphs ? null : graphID == 5 ? null : (
            <Button variant="outline-primary">
              <CSVLink data={csvData} filename={"course_data.csv"}>
                Download CSV
              </CSVLink>
            </Button>
          )}
          {graphID == 5 ? (
            <Button
              variant="outline-primary"
              onClick={(event) => {
                event.preventDefault();
                handleDownload();
              }}
            >
              Download XLSX
            </Button>
          ) : null}
          <Form.Group controlId="formCompany" style={{ marginLeft: "10px" }}>
            <Form.Control
              as="select"
              value={course}
              onChange={(e) => {
                setCourse(e.target.value);
                fetchCourseCompletionReport(
                  `${company}?courseId=${e.target.value}`
                );
              }}
            >
              <option value="">Select a course</option>
              {courses.map((course) => (
                <option key={course._id} value={course._id}>
                  {course.title}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          {!isGraphs && (graphID == 1 || graphID == 2) ? (
            <Form.Group controlId="formStatus" style={{ marginLeft: "10px" }}>
              <Form.Control
                as="select"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="">All Statuses</option>
                {graphID == 1
                  ? ["Completed", "In Progress", "Not Started"].map(
                      (status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      )
                    )
                  : graphID == 2
                  ? ["On Time", "Overdue", "Not Started"].map(
                      (status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      )
                    )
                  : ["On Time", "Overdue", "Not Started"].map(
                      (status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      )
                    )}
              </Form.Control>
            </Form.Group>
          ) : null}
          {graphID == 4 ? (
            <Form.Group
              controlId="formCompanyFilter"
              style={{ flex: 1, marginLeft: "10px" }}
            >
              <Form.Control
                className="w-100"
                style={{ width: "100%", borderRadius: "5px" }}
                as="select"
                value={selectedCategoryQuiz}
                onChange={(e) => {
                  setSelectedCategoryQuiz(e.target.value);
                }}
              >
                <option value="">All Category</option>
                {categoryQuizs.map((company) => (
                  <option key={company._id} value={company._id}>
                    {company.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          ) : null}
          {isGraphs ? (
            <Button
              variant="outline-primary"
              style={{
                fontWeight: "600",
                borderRadius: "5px",
                marginLeft: "10px",
              }}
              onClick={() => {
                const input = document.getElementById("divToPrint");

                // Get the width and height of the content to set the canvas size
                const width = input.offsetWidth;
                const height = input.offsetHeight;

                html2canvas(input, {
                  scrollY: -window.scrollY,
                  scale: 2,
                  width: width,
                  height: height,
                }).then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 1.0); // Use JPEG format for better compression
                  const pdf = new jsPDF("p", "px", [width, height]); // Set page size as per content size
                  pdf.addImage(imgData, "JPEG", 0, 0, width, height);
                  pdf.save("download.pdf");
                });
              }}
            >
              Download PDF
            </Button>
          ) : (
            <Button
              variant="outline-primary"
              style={{
                fontWeight: "600",
                borderRadius: "5px",
                marginLeft: "10px",
              }}
              onClick={() => {
                setIsGraphs(true);
                setGraphID(0);
                setCourseStatus(null);
              }}
            >
              Cancel
            </Button>
          )}
        </div>
      </Grid>
      <div style={{ marginTop: "10px" }} />
      {isGraphs ? (
        <Grid id="divToPrint" container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <Grid container xs={12} sm={12}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{
                    justifyContent: "start",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "16px",
                      color: "black",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Assigned Course Analysis
                  </h4>
                  <PieChart width={200} height={250}>
                    <Pie
                      data={courseCompletionReport}
                      labelLine={false}
                      label={renderCustomizedLabelPercent}
                      outerRadius={100}
                      dataKey="value"
                    >
                      {courseCompletionReport.map((entry, index) => (
                        <Cell
                          onClick={() => {
                            setFilter(entry.name);
                            setIsGraphs(false);
                            setGraphID(1);
                            fetchCourseStatus();
                          }}
                          key={`cell-${index}`}
                          fill={COLORS[index]}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                  <div
                    style={{
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: COLORS[0],
                        marginRight: "5px",
                      }}
                    />
                    <h5
                      style={{
                        fontSize: "10px",
                        color: "black",
                        fontFamily: "Noto Sans",
                        color: COLORS[0],
                        marginRight: "5px",
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    >
                      Completed
                    </h5>
                    <div
                      style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: COLORS[1],
                        marginRight: "5px",
                      }}
                    />
                    <h5
                      style={{
                        fontSize: "10px",
                        color: "black",
                        fontFamily: "Noto Sans",
                        color: COLORS[1],
                        marginRight: "5px",
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    >
                      In Progress
                    </h5>
                    <div
                      style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: COLORS[2],
                        marginRight: "5px",
                      }}
                    />
                    <h5
                      style={{
                        fontSize: "10px",
                        color: "black",
                        fontFamily: "Noto Sans",
                        color: COLORS[2],
                        marginRight: "5px",
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    >
                      Not Started
                    </h5>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{
                    justifyContent: "start",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h4
                    style={{
                      fontSize: "16px",
                      color: "black",
                      fontFamily: "Noto Sans",
                    }}
                  >
                    Overdue Course Analysis
                  </h4>
                  <PieChart width={200} height={250}>
                    <Pie
                      data={courseTimeCompletionReport}
                      labelLine={false}
                      label={renderCustomizedLabelPercent}
                      outerRadius={100}
                      dataKey="value"
                    >
                      {courseTimeCompletionReport.map((entry, index) => (
                        <Cell
                          onClick={() => {
                            if (entry.name == "Completed") {
                              setFilter("On Time");
                            } else {
                              setFilter("Overdue");
                            }
                            setIsGraphs(false);
                            setGraphID(2);
                            fetchCourseStatus();
                          }}
                          key={`cell-${index}`}
                          fill={COLORS[index]}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                  <div
                    style={{
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: COLORS[0],
                        marginRight: "5px",
                      }}
                    />
                    <h5
                      style={{
                        fontSize: "10px",
                        color: "black",
                        fontFamily: "Noto Sans",
                        color: COLORS[0],
                        marginRight: "5px",
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    >
                      Ontime
                    </h5>
                    <div
                      style={{
                        height: "10px",
                        width: "10px",
                        backgroundColor: COLORS[1],
                        marginRight: "5px",
                      }}
                    />
                    <h5
                      style={{
                        fontSize: "10px",
                        color: "black",
                        fontFamily: "Noto Sans",
                        color: COLORS[1],
                        marginRight: "5px",
                        marginTop: "0",
                        marginBottom: "0",
                      }}
                    >
                      Overdue
                    </h5>
                  </div>
                </Grid>
              </Grid>
              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  justifyContent: "start",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Top 10 Failed Question
                </h4>
                <PieChart width={200} height={250}>
                  <Pie
                    data={mostToLeast}
                    labelLine={false}
                    label={({
                      cx,
                      cy,
                      midAngle,
                      innerRadius,
                      outerRadius,
                      index,
                    }) => {
                      const radius =
                        innerRadius + (outerRadius - innerRadius) * 0.5;
                      const x = cx + radius * Math.cos(-midAngle * RADIAN);
                      const y = cy + radius * Math.sin(-midAngle * RADIAN);

                      return (
                        <text
                          x={x}
                          y={y}
                          fill="white"
                          textAnchor={x > cx ? "start" : "end"}
                          dominantBaseline="central"
                        >
                          {mostToLeast[index].value}
                        </text>
                      );
                    }} // Function to render label
                    outerRadius={100}
                    dataKey="value"
                  >
                    {mostToLeast.map((entry, index) => (
                      <Cell
                        onClick={() => {
                          setIsGraphs(false);
                          setGraphID(4);
                        }}
                        key={`cell-${index}`}
                        fill={failedList[index]}
                      />
                    ))}
                  </Pie>
                </PieChart>
                <div
                  style={{
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      backgroundColor: "grey",
                      marginRight: "5px",
                    }}
                  />
                  <h5
                    style={{
                      fontSize: "10px",
                      fontFamily: "Noto Sans",
                      color: "grey",
                      marginRight: "5px",
                      marginTop: "0",
                      marginBottom: "0",
                    }}
                  >
                    Different colors denote different quiz
                  </h5>
                </div>
              </Grid>
              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />

              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  justifyContent: "start",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Top 10 Emp with Most Attempts
                </h4>
                <PieChart width={200} height={250}>
                  <Pie
                    data={mostFailedEmployee}
                    labelLine={false}
                    label={({
                      cx,
                      cy,
                      midAngle,
                      innerRadius,
                      outerRadius,
                      index,
                    }) => {
                      const radius =
                        innerRadius + (outerRadius - innerRadius) * 0.5;
                      const x = cx + radius * Math.cos(-midAngle * RADIAN);
                      const y = cy + radius * Math.sin(-midAngle * RADIAN);

                      return (
                        <text
                          x={x}
                          y={y}
                          fill="white"
                          textAnchor={x > cx ? "start" : "end"}
                          dominantBaseline="central"
                        >
                          {mostFailedEmployee[index].value}
                        </text>
                      );
                    }} // Function to render label
                    outerRadius={100}
                    dataKey="value"
                  >
                    {mostFailedEmployee.map((entry, index) => (
                      <Cell
                        onClick={() => {
                          setIsGraphs(false);
                          setGraphID(5);
                          fetchCourseStatus();
                        }}
                        key={`cell-${index}`}
                        fill={failedList[index]}
                      />
                    ))}
                  </Pie>
                </PieChart>
                <div
                  style={{
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      backgroundColor: "grey",
                      marginRight: "5px",
                    }}
                  />
                  <h5
                    style={{
                      fontSize: "10px",
                      fontFamily: "Noto Sans",
                      color: "grey",
                      marginRight: "5px",
                      marginTop: "0",
                      marginBottom: "0",
                    }}
                  >
                    Different colors denote different quiz
                  </h5>
                </div>
              </Grid>
              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <div
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Question Report Category Wise
                </h4>
                <Form.Group controlId="formCompanyFilter">
                  <Form.Control
                    className="w-100"
                    style={{ width: "20%", borderRadius: "10px" }}
                    as="select"
                    value={selectedCategory}
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                    }}
                  >
                    <option value="">Select a category</option>
                    {category.map((company) => (
                      <option key={company._id} value={company._id}>
                        {company.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </div>
              <div style={{ height: "12px" }} />
              <BarChart
                width={1100}
                height={500}
                data={dataPercentage}
                margin={{
                  top: 10,
                  right: 20, // Increase the right margin to accommodate the legend
                  left: 20,
                  bottom: 100,
                }}
                onClick={(data, data2) => {
                  const fillColor = data2.target.getAttribute("fill"); // Extract the fill color
                  let attempt = 1;
                  if (fillColor == "green") {
                    //1
                    attempt = 1;
                  } else if (fillColor == "orange") {
                    //2
                    attempt = 2;
                  } else if (fillColor == "red") {
                    //3
                    attempt = 3;
                  }
                  let type = "awareness";
                  if (selectedCategory == 1) {
                    type = "awareness";
                  } else if (selectedCategory == 2) {
                    type = "compliance";
                  } else if (selectedCategory == 3) {
                    type = "nanobytes";
                  }
                  const result = categoryQuizs.find(
                    (e) => data.activeLabel == e.name
                  );
                  if (result != -1) {
                    fetchQuizCategoryTable(
                      `${company}/${result._id}/${attempt}/${type}`
                    );
                  }
                  setIsGraphs(false);
                  setGraphID(6);
                }}
              >
                <Legend
                  layout="horizontal" // Display legend horizontally
                  align="center" // Align the legend to the center
                  verticalAlign="top" // Align the legend to the bottom
                />
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  tick={{ fill: "black", fontSize: 12 }}
                  interval={0}
                  angle={-45}
                  textAnchor="end"
                />
                <YAxis domain={[0, 100]} tickFormatter={(tick) => `${tick}%`} />
                <Tooltip />

                <Bar
                  dataKey="attempt1"
                  stackId="a"
                  fill="green"
                  name={"Attempt 1"}
                />
                <Bar
                  dataKey="attempt2"
                  stackId="a"
                  fill="orange"
                  name={"Attempt 2"}
                />
                <Bar
                  dataKey="attempt3"
                  stackId="a"
                  fill="red"
                  name={"Attempt 3"}
                />
              </BarChart>

              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  justifyContent: "start",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Engagement Score
                </h4>
                <div
                  style={{
                    width: "190px", // Adjust width as needed
                    height: "190px", // Adjust height as needed
                    backgroundColor:
                      courseWithin14DaysCompletionReport > 75
                        ? "green"
                        : courseWithin14DaysCompletionReport >= 50
                        ? "orange"
                        : "red",
                    borderRadius: "20px",
                    display: "flex",
                    margin: "30px",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "48px", // Adjust font size as needed
                    color: "white",
                    boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)", // Shadow below the card
                  }}
                  onClick={() => {
                    setIsGraphs(false);
                    setGraphID(3);
                    fetchCourseStatus();
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {courseWithin14DaysCompletionReport
                      ? courseWithin14DaysCompletionReport
                          .toString()
                          .split(".")[0]
                      : "0"}
                  </span>
                </div>
                <div
                  style={{
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      backgroundColor: "green",
                      marginRight: "5px",
                    }}
                  />
                  <h5
                    style={{
                      fontSize: "10px",
                      color: "black",
                      fontFamily: "Noto Sans",
                      color: "green",
                      marginRight: "5px",
                      marginTop: "0",
                      marginBottom: "0",
                    }}
                  >
                    High
                  </h5>
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      backgroundColor: "orange",
                      marginRight: "5px",
                    }}
                  />
                  <h5
                    style={{
                      fontSize: "10px",
                      color: "black",
                      fontFamily: "Noto Sans",
                      color: "orange",
                      marginRight: "5px",
                      marginTop: "0",
                      marginBottom: "0",
                    }}
                  >
                    Medium
                  </h5>
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      backgroundColor: "red",
                      marginRight: "5px",
                    }}
                  />
                  <h5
                    style={{
                      fontSize: "10px",
                      color: "black",
                      fontFamily: "Noto Sans",
                      color: "red",
                      marginRight: "5px",
                      marginTop: "0",
                      marginBottom: "0",
                    }}
                  >
                    Low
                  </h5>
                </div>
              </Grid>
              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  justifyContent: "start",
                  alignContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Review Score
                </h4>
                <RatingChart
                  ratings={ratings}
                  onClick={() => {
                    setIsGraphs(false);
                    setGraphID(10);
                    fetchData(1);
                  }}
                />
              </Grid>
              <div style={{ height: "10px" }} />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Paper className={classes.paper}>
              <div style={{ height: "10px" }} />
              <div
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4
                  style={{
                    fontSize: "16px",
                    color: "black",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Learning/Risk Score
                </h4>
              </div>
              <div style={{ height: "12px" }} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <PieChart width={300} height={400}>
                  <Pie
                    data={[
                      {
                        name: "Score",
                        value: learningScoreChart.overallAverageScore
                          ? learningScoreChart.overallAverageScore
                          : 0,
                      },
                      {
                        name: "Not Scored",
                        value: learningScoreChart.overallAverageScore
                          ? 100 - learningScoreChart.overallAverageScore
                          : 0,
                      },
                    ]}
                    cx={150}
                    cy={200}
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="value"
                  >
                    <Cell key={`cell-1`} fill={"green"} />
                    <Cell key={`cell-2`} fill={"grey"} />
                    <Label
                      value={`${
                        learningScoreChart.overallAverageScore
                          ? learningScoreChart.overallAverageScore
                          : ""
                      }`}
                      position="center"
                      fill="#000"
                      fontSize={40}
                    />
                  </Pie>
                </PieChart>
                <BarChart
                  width={800}
                  height={600}
                  data={learningScoreChart.categoryPercentages}
                  onClick={(data, data2) => {
                    const result = categoryQuizs.find(
                      (e) => data.activeLabel == e.name
                    );
                    if (result !== undefined) {
                      // Checking for undefined, not -1
                      if (course !== "") {
                        fetchQuizCategoryTableScore(
                          `${company}/${result._id}/1/${course}`
                        );
                      } else {
                        fetchQuizCategoryTableScore(
                          `${company}/${result._id}/1/na`
                        );
                      }
                    }
                    setIsGraphs(false);
                    setGraphID(6);
                  }}
                  margin={{
                    top: 10,
                    right: 20, // Increase the right margin to accommodate the legend
                    left: 20,
                    bottom: 100,
                  }}
                >
                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 12 }}
                    interval={0}
                    angle={-45}
                    textAnchor="end"
                  />
                  <YAxis domain={[0, 100]} />
                  <Tooltip />
                  <Bar
                    dataKey="value"
                    fill="#8884d8"
                    label={{
                      position: "top",
                      fill: "black",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  />
                </BarChart>
              </div>
              <div style={{ height: "10px" }} />
              <LeaderboardTable
                endpoint={`/leaderboard/${company}`}
                title={"Top 10 Students"}
              />
              {/* <LeaderboardTable
                endpoint={`/leaderboard-bottom/${company}`}
                title={"Bottom 10 Students"}
              /> */}
              {/* <LeaderboardTable endpoint=/leaderboard/:companyId/bottom" /> */}
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <div
          style={{
            width: "100%",
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {graphID == 1 ? (
            courseStatus ? (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Email</th>
                    <th>Course Name</th>
                    <th>Status</th>
                    <th>Creation Date</th>
                    <th>Due Date</th>
                    <th>Completion Date</th>
                  </tr>
                </thead>
                <tbody>
                  {courseStatus.response.data
                    .filter(
                      (item) =>
                        filter === "" ||
                        filter === "All" ||
                        item.status === filter
                    ) // Apply filter
                    .sort((a, b) => a.status.localeCompare(b.status))
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {item.user.firstName} {item.user.lastName}
                          </td>
                          <td>{item.user.email}</td>
                          <td>{item.course.title}</td>
                          <td>{item.status}</td>
                          <td>
                            {item.course
                              ? new Date(item.course.createdAt).toLocaleString(
                                  "en-IN",
                                  { timeZone: "Asia/Kolkata" }
                                )
                              : "N/A"}
                          </td>
                          <td>
                            {item.course
                              ? new Date(item.course.dueDate).toLocaleString(
                                  "en-IN",
                                  { timeZone: "Asia/Kolkata" }
                                )
                              : "N/A"}
                          </td>
                          <td>
                            {item.courseCompletionDate
                              ? new Date(
                                  item.courseCompletionDate
                                ).toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                })
                              : "N/A"}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            ) : (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )
          ) : null}
          {graphID == 2 ? (
            courseStatus ? (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Email</th>
                    <th>Course Name</th>
                    <th>Status</th>
                    <th>Creation Date</th>
                    <th>Due Date</th>
                    <th>Completion Date</th>
                  </tr>
                </thead>
                <tbody>
                  {courseStatus.responseTime.data
                    .filter(
                      (item) =>
                        filter === "" ||
                        filter === "All" ||
                        item.status === filter
                    ) // Apply filter
                    .sort((a, b) => a.status.localeCompare(b.status))
                    .sort((a, b) => a.status.localeCompare(b.status))
                    .map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.user.firstName} {item.user.lastName}
                        </td>
                        <td>{item.user.email}</td>
                        <td>{item.course.title}</td>
                        <td>{item.status}</td>
                        <td>
                          {item.course
                            ? new Date(item.course.createdAt).toLocaleString(
                                "en-IN",
                                { timeZone: "Asia/Kolkata" }
                              )
                            : "N/A"}
                        </td>
                        <td>
                          {item.course
                            ? new Date(item.course.dueDate).toLocaleString(
                                "en-IN",
                                { timeZone: "Asia/Kolkata" }
                              )
                            : "N/A"}
                        </td>
                        <td>
                          {item.courseCompletionDate
                            ? new Date(
                                item.courseCompletionDate
                              ).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ) : (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )
          ) : null}
          {graphID == 3 ? (
            courseStatus ? (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Email</th>
                    <th>Course Name</th>
                    <th>Status</th>
                    <th>Creation Date</th>
                    <th>Due Date</th>
                    <th>Completion Date</th>
                  </tr>
                </thead>
                <tbody>
                  {courseStatus.responseWithin14Days.data
                    .filter((item) => item.courseCompletionDate) // Apply filter
                    .sort((a, b) => a.status.localeCompare(b.status))
                    .map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.user.firstName} {item.user.lastName}
                        </td>
                        <td>{item.user.email}</td>
                        <td>{item.course.title}</td>
                        <td>{item.status}</td>
                        <td>
                          {item.course
                            ? new Date(item.course.createdAt).toLocaleString(
                                "en-IN",
                                { timeZone: "Asia/Kolkata" }
                              )
                            : "N/A"}
                        </td>
                        <td>
                          {item.course
                            ? new Date(item.course.dueDate).toLocaleString(
                                "en-IN",
                                { timeZone: "Asia/Kolkata" }
                              )
                            : "N/A"}
                        </td>
                        <td>
                          {item.courseCompletionDate
                            ? new Date(
                                item.courseCompletionDate
                              ).toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                              })
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ) : (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )
          ) : null}
          {graphID == 4 ? (
            mostToLeast ? (
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Attempts</th>
                    <th>Category</th>
                    <th>Course</th>
                    <th>Material</th>
                    <th>Quiz</th>
                  </tr>
                </thead>
                <tbody>
                  {mostToLeast
                    .filter(
                      (item) =>
                        selectedCategoryQuiz === "" ||
                        selectedCategoryQuiz === "All" ||
                        item.categoryID._id === selectedCategoryQuiz
                    ) // Apply filter
                    .sort((a, b) => b.value - a.value)
                    .map((item, index) => {
                      const material = item.courseID.videosWithQuizzes.find(
                        (element) => element._id == item.materialID
                      );
                      const quiz = material
                        ? material.quiz.find(
                            (element) => element._id == item.name
                          )
                        : null;
                      return (
                        <tr key={index}>
                          <td>{item.value}</td>
                          <td>{item.categoryID.name}</td>
                          <td>{item.courseID.title}</td>
                          <td>{material ? material.video.title : ""}</td>
                          <td>{quiz ? quiz.question : ""}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            ) : (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )
          ) : null}
          {graphID == 5 ? (
            mostFailedEmployee ? (
              <Table striped bordered hover id="table-to-download">
                <thead>
                  <tr>
                    <th>Total Attempts</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Failed Quizzes</th>
                  </tr>
                </thead>
                <tbody>
                  {mostFailedEmployee
                    .sort((a, b) => b.value - a.value)
                    .map((employee, index) => (
                      <tr key={index}>
                        <td>{`${employee.value}`}</td>
                        <td>{`${employee.name.firstName} ${employee.name.lastName}`}</td>
                        <td>{`${employee.name.email}`}</td>
                        <td>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Quiz</th>
                                <th>Material</th>
                                <th>Course</th>
                                <th>Category</th>
                                <th>Times Failed</th>
                              </tr>
                            </thead>
                            <tbody>
                              {employee.failedQuizzes
                                .sort((a, b) => b.timesFailed - a.timesFailed)
                                .map((item, index) => {
                                  const material =
                                    item.courseID.videosWithQuizzes.find(
                                      (element) =>
                                        element._id == item.materialID
                                    );
                                  const quiz = material
                                    ? material.quiz.find(
                                        (element) => element._id == item.quizID
                                      )
                                    : null;
                                  return (
                                    <tr key={index}>
                                      <td>{quiz ? quiz.question : ""}</td>
                                      <td>
                                        {material ? material.video.title : ""}
                                      </td>
                                      <td>{item.courseID.title}</td>
                                      <td>{item.categoryID.name}</td>
                                      <td>{item.timesFailed}</td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ) : (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )
          ) : null}
          {graphID == 6 ? (
            <Table striped bordered hover>
              <thead>
                <tr style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                  <th style={{ flex: 4 }}>Quiz</th>
                  <th style={{ flex: 1 }}>Material</th>
                  <th style={{ flex: 1 }}>Course</th>
                  <th style={{ flex: 1 }}>Total Count</th>
                  <th style={{ flex: 3 }}>Students</th>
                </tr>
              </thead>
              <tbody>
                {quizTrackingData.map((item, index) => {
                  const material = item.courseID.videosWithQuizzes.find(
                    (element) => element._id == item.materialID
                  );
                  const quiz = material
                    ? material.quiz.find(
                        (element) => element._id == item.quizID
                      )
                    : null;
                  return (
                    <tr
                      key={index}
                      style={{
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        flex: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <td style={{ flex: 4 }}>{quiz ? quiz.question : ""}</td>
                      <td style={{ flex: 1 }}>
                        {material ? material.video.title : ""}
                      </td>
                      <td style={{ flex: 1 }}>{item.courseID.title}</td>
                      <td style={{ flex: 1 }}>{item.totalCount}</td>
                      <td style={{ flex: 3 }}>
                        <ul>
                          {item.employees.map((employee, empIndex) => (
                            <li key={empIndex}>
                              {employee
                                ? `${employee.firstName} ${employee.lastName} - ${employee.email}`
                                : "N/A"}
                            </li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : null}
          {graphID == 10 ? (
            ratingsData.length > 0 ? (
              <table
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
                className="table table-striped table-bordered table-hover"
              >
                <thead>
                  <tr
                    style={{ flex: 1, display: "flex", flexDirection: "row" }}
                  >
                    <td style={{ flex: 3 }}>User</td>
                    <td style={{ flex: 3 }}>Course Title</td>
                    <td style={{ flex: 1 }}>Rating</td>
                    <td style={{ flex: 9 }}>Review</td>
                  </tr>
                </thead>
                <tbody>
                  {ratingsData.map((rating) => (
                    <tr
                      key={rating._id}
                      style={{
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        flex: 1,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <td style={{ flex: 3 }}>
                        {rating.employee
                          ? `${rating.employee.firstName} ${rating.employee.lastName}`
                          : ""}
                      </td>
                      <td style={{ flex: 3 }}>
                        {rating.course ? rating.course.title : ""}
                      </td>
                      <td style={{ flex: 1 }}>{rating.rating}</td>
                      <td style={{ flex: 9 }}>{rating.review}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ margin: "20px", textAlign: "center" }}>
                No ratings found, please try again!
              </div>
            )
          ) : null}
        </div>
      )}
    </Grid>
  );
};

export default ReportManage;
